export class MatchingProfileReason {
  id: number;
  referenceDataId: number;
  matchingProfileId: number;
  name: string;
  description: string;

  load_from_json(json: any): MatchingProfileReason {
    this.id = json.id;
    this.referenceDataId = json.reference_data_id;
    this.matchingProfileId = json.matching_profile_id;
    this.name = json.name;
    this.description = json.description;

    return this;
  }
}
